import { LegalPage } from "@/components/legal/LegalPage";
import { SELLER } from "@/config/legal";

const RefundPolicy = () => (
  <LegalPage title="Refund Policy" description="Veylo AI's 30-day money-back guarantee." path="/refund-policy">
    <section>
      <h2>{SELLER.refundDays}-day money-back guarantee</h2>
      <p>
        If you are not satisfied with {SELLER.productName}, you can request a full refund within {SELLER.refundDays} days of your order date.
        This applies to your first payment and to each renewal.
      </p>
    </section>
    <section>
      <h2>How to request a refund</h2>
      <ul>
        <li>Visit <a href="https://paddle.net" target="_blank" rel="noopener noreferrer">paddle.net</a> and look up your order using the email on your receipt, or</li>
        <li>Email us at <a href={`mailto:${SELLER.supportEmail}`}>{SELLER.supportEmail}</a> with your order number.</li>
      </ul>
    </section>
    <section>
      <h2>Who processes refunds</h2>
      <p>
        Our order process is conducted by our online reseller Paddle.com, the Merchant of Record for all our orders.
        Refunds are returned to your original payment method by Paddle. See also{" "}
        <a href="https://www.paddle.com/legal/refund-policy" target="_blank" rel="noopener noreferrer">Paddle's Refund Policy</a>.
      </p>
    </section>
    <section>
      <h2>Cancelling</h2>
      <p>You can cancel any time from the Billing page. Your plan stays active until the end of the period you paid for.</p>
    </section>
  </LegalPage>
);

export default RefundPolicy;
